import {
	Card,
	CardBody,
	CardHeader,
} from "@tql/ui-components-react/kendo/layout";
import { useAtomValue } from "jotai";

import type { ShipmentAdditionalDetails } from "~/shared/schemas/shipment-management-schema";
import { formatPhoneNumber } from "~/shared/utils/string-fns.ts";

import { isEditingShipmentAtom } from "../../state/shipment-edit-atoms.ts";
import { ADDITIONAL_DETAILS_DEFAULT } from "../../utils/defaults.ts";
import { AdditionalDetailsEdit } from "./additional-details-edit.tsx";

export const AdditionalDetails = ({
	details = ADDITIONAL_DETAILS_DEFAULT,
}: {
	details?: ShipmentAdditionalDetails;
}) => {
	const isEditing = useAtomValue(isEditingShipmentAtom);

	if (isEditing) {
		return <AdditionalDetailsEdit details={details} />;
	}

	return (
		<div
			className={"card-wrapper"}
			data-testid={"shipment-management-reference-details"}
		>
			<Card>
				<CardHeader>
					<h3>Reference Information</h3>
				</CardHeader>
				<CardBody>
					<div className={"reference-details"}>
						{details.emergencyContactName ? (
							<div className={"reference-row"}>
								<div className={"reference-field"}>
									<div className={"section-label"}>Emergency Contact Name</div>
									<div>{details.emergencyContactName}</div>
								</div>
								<div className={"reference-field"}>
									<div className={"section-label"}>
										Emergency Contact Number
									</div>
									<div>
										{details.emergencyContactNumber
											? formatPhoneNumber(details.emergencyContactNumber)
											: "N/A"}
									</div>
								</div>
							</div>
						) : null}

						<div className={"reference-row"}>
							<div className={"reference-field"}>
								<div className={"section-label"}>Customer Reference</div>
								<div data-testid={"reference-customer"}>
									{details.customerReference ?? "N/A"}
								</div>
							</div>
							<div className={"reference-field"}>
								<div className={"section-label"}>SO Number</div>
								<div data-testid={"reference-so-number"}>
									{details.soNumber ?? "N/A"}
								</div>
							</div>
							<div className={"reference-field"}>
								<div className={"section-label"}>PO Number</div>
								<div data-testid={"reference-po-number"}>
									{details.customerPONumber ?? "N/A"}
								</div>
							</div>
						</div>
					</div>
				</CardBody>
			</Card>
		</div>
	);
};
